import { LibraryElementEnum } from 'client/enums/LibraryElementEnum'
import { CommonLibraryElementsCreator } from 'src/editor/shared/entities/common-library-elements-creator'
import { createWebsiteButton } from 'src/shared/entities/website-button/create-website-button'

export class WebsiteLibraryElementsCreator extends CommonLibraryElementsCreator {
  public [LibraryElementEnum.LibraryButton](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryButton]
    >
  ) {
    const button = super[LibraryElementEnum.LibraryButton](...args)
    delete button.border
    delete button.mobileBorder
    delete button.padding
    delete button.mobilePadding
    delete button.background
    delete button.mobileBackground
    delete button.textColor
    delete button.textFontFamily
    delete button.textFontSize
    delete button.textFontWeight
    delete button.textFontStyle
    delete button.lineHeight
    delete button.mobileTextFontFamily
    delete button.mobileTextFontSize
    delete button.mobileTextFontWeight
    delete button.mobileTextFontStyle
    delete button.mobileLineHeight
    delete button.hover?.backgroundColor
    delete button.mobileHover?.backgroundColor

    return button
  }
  public [LibraryElementEnum.LibraryWebsiteButton](
    ...args: Parameters<typeof createWebsiteButton>
  ) {
    return createWebsiteButton(...args)
  }
  public [LibraryElementEnum.LibraryField](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryField]
    >
  ) {
    const field = super[LibraryElementEnum.LibraryField](...args)
    delete field.border
    delete field.mobileBorder
    delete field.padding
    delete field.mobilePadding
    delete field.backgroundColor
    delete field.mobileBackgroundColor
    delete field.color
    delete field.mobileColor
    delete field.mobileFontSize
    delete field.fontSize
    delete field.mobileFontSize
    delete field.mobileFontSize
    delete field.textAlign
    delete field.mobileTextAlign
    delete field.lineHeight
    delete field.mobileLineHeight

    return field
  }
  public [LibraryElementEnum.LibraryMenu](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryMenu]
    >
  ) {
    const menu = super[LibraryElementEnum.LibraryMenu](...args)
    delete menu.subMenuBackgroundColor
    delete menu.sideMenuBackgroundColor
    return menu
  }
  public [LibraryElementEnum.LibraryHeadline](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryHeadline]
    >
  ) {
    const headline = super[LibraryElementEnum.LibraryHeadline](...args)
    delete headline.fontSize
    delete headline.mobileFontSize
    delete headline.lineHeight
    delete headline.mobileLineHeight
    return headline
  }
  public [LibraryElementEnum.LibraryPopup](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryPopup]
    >
  ) {
    const popup = super[LibraryElementEnum.LibraryPopup](...args)
    delete popup.border
    delete popup.mobileBorder
    delete popup.background
    delete popup.mobileBackground
    return popup
  }

  // TODO: add other website entity creators here
  // ...
}
